// extracted by mini-css-extract-plugin
export default {"errorSection":"AutomatedStepErrorSection_errorSection__VDCmV"};